import { AUTH_CHECK, AUTH_ERROR, AUTH_GET_PERMISSIONS, AUTH_LOGIN, AUTH_LOGOUT } from 'react-admin';
import config from './config';
import decodeJwt from 'jwt-decode';
import { STATE_REQUEST_HASH_KEY } from './GlobalState/constants';

const env = process.env.REACT_APP_CUSTOM_NODE_ENV;
const EXPIRES_IN_KEY = 'expiresIn';

const clearAuthStorage = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('permissions');
    localStorage.removeItem(EXPIRES_IN_KEY);
    localStorage.removeItem(STATE_REQUEST_HASH_KEY);
};

const getExpiresAtIsoString = expiresInSec => {
    const expiresInSeconds = Number(expiresInSec);

    if (!Number.isFinite(expiresInSeconds) || expiresInSeconds < 0) {
        return null;
    }

    return new Date(Date.now() + expiresInSeconds * 1000).toISOString();
};

export default (type, params) => {
    // called when the user attempts to log in
    const URL = config[env].url;
    if (type === AUTH_LOGIN) {
        const { username, password } = params;
        const request = new Request(URL + 'iam/employees/login', {
            method: 'POST',
            body: JSON.stringify({ email: username, password: password }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });
        return fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error(response.statusText);
                }
                return response.json();
            })
            .then(({ token, expiresInSec }) => {
                const decodedToken = decodeJwt(token);
                const expiresAtIsoString = getExpiresAtIsoString(expiresInSec);

                localStorage.setItem('token', token);
                localStorage.setItem('permissions', decodedToken.role);
                if (expiresAtIsoString) {
                    localStorage.setItem(EXPIRES_IN_KEY, expiresAtIsoString);
                } else {
                    localStorage.removeItem(EXPIRES_IN_KEY);
                }
                // console.log(decodedToken.role)
            });
        // accept all username/password combinations
        // const { username } = params;
        // localStorage.setItem('token', username);
        // return Promise.resolve();
    }
    // called when the user clicks on the logout button
    if (type === AUTH_LOGOUT) {
        clearAuthStorage();
        return Promise.resolve();
    }
    // called when the API returns an error
    if (type === AUTH_ERROR) {
        const { status } = params;
        if (status === 401 || status === 403) {
            clearAuthStorage();
            return Promise.reject();
        }
        return Promise.resolve();
    }
    // called when the user navigates to a new Locations
    if (type === AUTH_CHECK) {
        const token = localStorage.getItem('token');

        if (!token) {
            return Promise.reject();
        }

        const expiresIn = localStorage.getItem(EXPIRES_IN_KEY);

        if (expiresIn) {
            const expiresAt = new Date(expiresIn);

            if (!Number.isNaN(expiresAt.getTime()) && expiresAt.getTime() <= Date.now()) {
                clearAuthStorage();
                return Promise.reject();
            }
        }

        return Promise.resolve();
    }
    if (type === AUTH_GET_PERMISSIONS) {
        const permissions = localStorage.getItem('permissions');
        return permissions ? Promise.resolve(permissions) : Promise.reject();
    }
    return Promise.reject('Unknown method');
};
